import type { TFunction } from "i18next";

/** Item statuses, in the order of the backend OrderStatus enum. */
export const ORDER_STATUS_VALUES = Array.from({ length: 32 }, (_, index) => index);

export const STATUS_REFUNDED = 18;
export const STATUS_DELIVERED = 25;
export const STATUS_APPROVED = 6;
const INACTIVE_STATUSES = [2, 4, 8, 12, 16, 18, 29];
const REJECTED_STATUSES = [2, 4, 8];
const CANCELLED_STATUSES = [12, 29];

export const isActiveStatus = (status: number) => !INACTIVE_STATUSES.includes(status);
export const isRejectedStatus = (status: number) => REJECTED_STATUSES.includes(status);
export const isCancelledStatus = (status: number) => CANCELLED_STATUSES.includes(status);
/** A rejected or cancelled item is out of the group for good. */
export const isFinalStatus = (status: number) => isRejectedStatus(status) || isCancelledStatus(status);

export const statusLabel = (t: TFunction, status: number) =>
  t(`orders:statusOptions.${status}`, { defaultValue: String(status) });

export const statusBadgeClass = (status: number) => {
  if (status === STATUS_DELIVERED) return "bg-success";
  if (status === STATUS_REFUNDED) return "bg-dark";
  if (!isActiveStatus(status)) return "bg-danger";
  if (status === STATUS_APPROVED || status === 9) return "bg-warning text-dark";
  return "bg-secondary";
};

export const orderTypeLabel = (t: TFunction, orderType: number) =>
  orderType === 1 ? t("orderGroups.types.shipForMe") : t("orderGroups.types.buyForMe");

export const money = (value?: number | null) => Number(value || 0).toFixed(2);

export interface OrderGroupStatusCount {
  status: number;
  count: number;
}
